import type { WirePayloadAction } from './wire-action.js'

export interface WebRTCMessageBase {
  entityId: string
  timestamp?: number
}

/** Our messages to acquire ICE servers */
export interface ICEServers {
  iceServers: RTCIceServer[]
  expires: number
}

/** A message sent to a participant specified by receiverClientId  */
export interface DirectedMessage extends WebRTCMessageBase {
  receiverClientId: string
}

export interface VideoMessage extends DirectedMessage {
  senderClientId: string
}

/** These messages are directed, i.e., they should be sent to a specific peer */
export function isDirectedMessage(msg?: WirePayloadAction<unknown>): msg is WirePayloadAction<DirectedMessage> {
  return Boolean(msg?.payload && typeof msg.payload === 'object' && 'receiverClientId' in msg.payload)
}

export function isVideoMessage(msg: WirePayloadAction<unknown>): msg is WirePayloadAction<VideoMessage> {
  return Boolean(msg?.payload && typeof msg.payload === 'object' && 'senderClientId' in msg.payload)
}
